import { useMemo } from 'react';
import { useBreakpointValue } from '@stockx/ui';
import { useLocation } from '@app/router';

type ContentVariants = 'buysell' | 'auth' | 'human' | 'favorites';

const pattern = /favorites\/.+/;

/**
 * app: header ends up being hidden
 * buysell: on desktop buy or sell flows we show a simplified header
 * auth: used for various auth pages. shows a simple logo only header.
 * standard: the usual header experience
 * favorites: the favorites header experience
 */
const useContentVariant = (): ContentVariants => {
  const { isMobile } = useBreakpointValue();
  const { pathname } = useLocation();

  return useMemo(() => {
    if (
      !isMobile &&
      ((pathname.includes('/sell') && !pathname.includes('/selling')) ||
        (pathname.includes('/buy') && !pathname.includes('/buying')))
    ) {
      return 'buysell';
    }

    if (
      pathname?.includes('social-confirm') ||
      pathname?.includes('gdpr') ||
      pathname?.includes('reset-password-confirmation')
    ) {
      return 'auth';
    }

    if (
      isMobile &&
      pathname?.includes('/favorites') &&
      pattern.test(pathname)
    ) {
      return 'favorites';
    }

    return 'human';
  }, [isMobile, pathname]);
};

export default useContentVariant;
